import axios, { AxiosError, isCancel } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFromLocalStorage } from '../components/helper/authorizationHelper';
import BASEURL from '../components/helper/axiosHelper';
import { selectAuth } from '../features/authSlice';
import { getStorage } from '../libs/getStorage';
import { iterateSessionStorage } from '../libs/iterateSessionStorage';
const useAuth = () => {
  const { user, isAuthenticated } = useSelector(selectAuth);
  const [isLogin, setLogin] = useState(false);
  const [token, setToken] = useState(getStorage('token'));
  const [refreshTokenError, setRefreshTokenError] = useState(null);
  const message = localStorage.getItem('message');
  const [epUserID, setEpUserID] = useState(null);


  const data = iterateSessionStorage()

  useEffect(() => {
    localStorage.setItem('isHome', false);

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
      });

  }, [epUserID]);

  const refreshToken = useCallback(
    async (signal, userID) => {
      try {
        if (userID !== null) {
          const obj = {
            id: userID,
            refreshToken: data?.refreshToken,
            userName: data?.userName,
            Email: data?.email,
            Role: data?.role
          }

          const response = await axios.post(
            `${BASEURL}/Authentication/RefreshToken`, obj,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
              },
              signal
            }
          );
          if (response.data.statusCode === 200) {
            localStorage.setItem('token', response.data.value);
            setToken(response.data.value);

            setRefreshTokenError(null);
          } else {
            setRefreshTokenError(response.data);
          }
        }
      }

      catch (error) {
        if (isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          setRefreshTokenError(error);
          if (error instanceof AxiosError && error.response?.status === 401) {
            setLogin(false);
            localStorage.removeItem('token');
            localStorage.removeItem('upid');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userName');
            localStorage.removeItem('name');
            localStorage.removeItem('role');
            localStorage.removeItem('email');
            localStorage.removeItem('statusCode');
            localStorage.removeItem('message');
            localStorage.removeItem('userId');
          }
        }
      }
    },
    [token]
  );

  const handleRefreshToken = useCallback(() => {
    if (epUserID !== null) {
      const controller = new AbortController();
      const { signal } = controller;
      let userID = epUserID
      refreshToken(signal, userID);
      return () => controller.abort();
    }
  }, [refreshToken, epUserID]);

  useEffect(() => {
    setLogin(!!token);
  }, [token]);

  useEffect(() => {
    let intervalId;
    if (isLogin) {
      // 10Mints
      intervalId = setInterval(handleRefreshToken, 600000);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [handleRefreshToken, isLogin]);



  return {
    isLogin,
    token,
    refreshTokenError,
    handleRefreshToken
  };
};

export default useAuth;
